export { default } from './Rewards';
